import { FONT, RADIUS } from "@/styles/common";
import { Center } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const Wrapper = styled(Center)`
    width: 720px;
    height: 120px;
    padding: 0 72px;
    box-sizing: border-box;
    color: ${({ theme }) => theme.COLOR.white};
    background: ${({ theme }) => theme.COLOR.black};
    ${FONT("pretendard", 20, 500)}
    ${RADIUS(2)}

    @media (max-width:${({ theme }) => theme.MEDIA.mobile}) {
        width: 280px;
        height: 84px;
        ${FONT("pretendard", 14, 500)}
        padding: 0 24px;
    }
`;
